import { Helmet } from 'react-helmet';

import Header from '../components/Products/Header';
import Body from '../components/Products/Body';

import { categories, ingredients } from '../resource/Products';

function Products(props) {
  const {
    match: {
      params: { path, section },
    },
  } = props;

  const selection =
    section === 'category'
      ? categories.filter((category) => category.path === path)
      : ingredients.filter((ingredient) => ingredient.path === path);

  return (
    <div className="products__container column">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {selection.length !== 0 ? selection[0].name : '제품보기'} - 라이프스팬
        </title>
      </Helmet>
      <Header selection={selection || null} />
      <Body section={section} selection={selection} />
    </div>
  );
}

export default Products;
